import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${({ theme }) => css`
    column-gap: ${theme.space.xs};
    @media (max-width: ${theme.breakpoints.sm}) {
      grid-template-columns: 100%;
      row-gap: ${theme.space.md};

      ${Back} {
        margin-right: unset;
        margin-left: auto;
      }

      ${Selector} {
        align-items: center;
        .ant-select.ant-select-enabled {
          max-width: 215px;
        }
        grid-template-columns: repeat(2, minmax(0, 50%));
      }

      ${ClockWrapper} {
        max-width: 100%;
        width: 100%;
      }
    }
  `}
`

export const Selector = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${({ theme }) => theme.space.sm};
`

export const SelectWrapper = styled.div`
  ${({ theme }) => css`
    .ant-select-selection {
      height: 46px;
      font-size: ${theme.fontSize.xl};
      font-weight: ${theme.fontWeight.bold};
      display: flex;
      align-items: center;
      padding-right: 45px;
    }
    .ant-select-arrow {
      font-size: ${theme.fontSize.lg};
      top: 39%;
    }
    .ant-select {
      max-width: 300px;
      min-width: 215px;
      width: 100%;
    }
    .ant-select-selection__rendered {
      overflow: hidden;
    }
  `}
`

export const ClockWrapper = styled.div`
  max-width: max-content;
  margin-left: auto;
`

export const Back = styled.div`
  margin-right: auto;

  button {
    margin-bottom: 0;
  }
`
